<template>
  <b-container fluid>
    <b-card title="">
      <metabase :code="927" />
    </b-card>
  </b-container>
</template>
<script>
import {
    BContainer,
    BCard,
} from 'bootstrap-vue';

import Metabase from '../components/Metabase.vue';

export default {
    components: {
        BContainer,
        BCard,
        Metabase,
    },
};
</script>
